import React from "react";
import { useTranslation, Trans } from "react-i18next";

export const RealizationsBannerSection = () => {
  const { t } = useTranslation();

  return (
    <section className="banner-section">
      <div class="realizations-banner">
        <div class="realizations-shape-cutout">
          <h1 class="title">{t("realizations.title")}</h1>
          <p>
            <Trans t={t} i18nKey="realizations.text_1" />
          </p>
        </div>
      </div>
    </section>
  );
};
